import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { IBookingIntegration } from '../utils/models/booking-integration-model';
import { OneCModel } from '../utils/models/OneCModel';

export function usePostOneCIntegration() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (data: OneCModel) => {
      const res = await $api.post(endPoints.ONE_C, data);

      return res.data;
    },
    onSuccess: async res => {
      await qc.invalidateQueries([queryKeys.ONE_C]);

      showMessage(res.message, res.accept);
    },
    onError: baseErrorHandler
  });
}

export function useChangeBookingConfig(onCancel: () => void) {
  const qc = useQueryClient();

  return useMutation(
    async (payload: Partial<Omit<IBookingIntegration, 'houses'> & { houses: { id: number; name: string }[] }>) => {
      const { data } = await $api.post('/v1/marketplace-booking-config', payload);

      return data;
    },
    {
      onSuccess: async res => {
        await qc.invalidateQueries([queryKeys.MARKETPLACE_BOOKING_CONFIG]);

        showMessage(res.message, res.accept);

        onCancel();
      },
      onError: baseErrorHandler
    }
  );
}
